import React from "react";
import { useOutletContext, Link } from "react-router-dom";

export default function AboutPage() {
  const { content } = useOutletContext() || {};
  const about = content?.about;

  return (
    <div data-testid="about-page">
      <section className="relative overflow-hidden px-6 pb-16 pt-20 md:pb-24 md:pt-28">
        <div className="absolute inset-0 radial-glow" />
        <div className="relative mx-auto max-w-7xl">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-fuchsia-400">About us</p>
          <h1 className="mt-4 text-5xl font-bold tracking-tighter text-white md:text-7xl" data-testid="about-title">
            {about?.title || "A Full-Service Digital Agency"}
          </h1>
          <p className="mt-6 max-w-3xl text-lg text-white/70" data-testid="about-lead">
            {about?.lead}
          </p>
        </div>
      </section>

      <section className="px-6 pb-16">
        <div className="mx-auto grid max-w-7xl gap-4 md:grid-cols-4" data-testid="about-stats">
          {(about?.stats || []).map((s) => (
            <div key={s.label} className="rounded-2xl border border-white/10 bg-[#131B2F] p-6">
              <div className="text-3xl font-bold tracking-tight gradient-text md:text-4xl">{s.value}</div>
              <div className="mt-2 text-sm text-white/60">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="px-6 py-16">
        <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-12">
          <div className="md:col-span-7">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-fuchsia-400">Our story</p>
            <h2 className="mt-3 text-4xl font-bold tracking-tight text-white md:text-5xl">
              Craft meets <span className="gradient-text">data.</span>
            </h2>
            <p className="mt-6 whitespace-pre-line text-base leading-relaxed text-white/70 md:text-lg" data-testid="about-body">
              {about?.body}
            </p>
          </div>
          <div className="space-y-5 md:col-span-5">
            <div className="rounded-2xl border border-white/10 bg-[#131B2F] p-8">
              <div className="text-xs uppercase tracking-[0.25em] text-fuchsia-400">Mission</div>
              <p className="mt-3 text-lg text-white/90">{about?.mission}</p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-[#131B2F] p-8">
              <div className="text-xs uppercase tracking-[0.25em] text-fuchsia-400">Vision</div>
              <p className="mt-3 text-lg text-white/90">{about?.vision}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="mx-auto max-w-7xl overflow-hidden rounded-3xl border border-white/10 bg-[#131B2F] p-10 md:p-16">
          <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
            <div className="max-w-2xl">
              <h3 className="text-3xl font-bold tracking-tight text-white md:text-5xl">
                Let's build something <span className="gradient-text">remarkable.</span>
              </h3>
            </div>
            <Link
              to="/contact"
              data-testid="about-cta"
              className="inline-flex items-center gap-2 rounded-full gradient-bg px-7 py-3.5 text-sm font-semibold text-white"
            >
              Start a project
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
